/**
 * Manages all the logic for the product how subscription works modal
 */

/**
 * Injects the CTA button into the subscription modal
 * @param containerParent
 */
const injectModalCTA = (containerParent) => {
    let subscriptionButton = containerParent.querySelector('.appstle_subscribe_option_grid .appstle_select_label');
    if (typeof subscriptionButton != 'undefined' && subscriptionButton != null) {
        //Detect if the button is already present
        let alreadyExistingBtn = document.querySelector('.how-subscription-works-cta');
        if (typeof alreadyExistingBtn != 'undefined' && alreadyExistingBtn != null) {
            return;
        }
        //Add the new label pseudo-button
        let newButton = document.createElement('span');

        //Link to the modal objects
        let modalOverlay = document.querySelector('.hsw-overlay');
        let modalClose = document.querySelector('.hsw-body-close-btn');

        //Listener actions
        newButton.addEventListener('click', () => {
            modalOverlay.style.display = 'flex';
        });

        //Close modal listener
        modalClose.addEventListener('click', () => {
            modalOverlay.classList.add('fade-out');
            window.setTimeout(() => {
                modalOverlay.style.display = 'none';
                modalOverlay.classList.remove('fade-out');
            }, 500);
        });

        //Out-of-modal / overlay click listener
        modalOverlay.addEventListener('click', (event) => {
            if (event.target.classList.contains('hsw-overlay')) {
                modalOverlay.classList.add('fade-out');
                window.setTimeout(() => {
                    modalOverlay.style.display = 'none';
                    modalOverlay.classList.remove('fade-out');
                }, 500);
            }
        });

        //Add the new button with all it's logic
        newButton.classList.add('how-subscription-works-cta');
        newButton.innerHTML = str_how_subscription_works;
        subscriptionButton.appendChild(newButton);
    }
};

/**
 * Entry function to add the modal and CTA functionality
 * @param firstCall
 */
const bootstrapHowSubsWorksModal = (firstCall = false) => {
    let containerParent = document.querySelector('.payAsYouGoPlansDropdownWrapper');
    if (typeof containerParent === 'undefined' || containerParent === null) {
        window.setTimeout(() => {bootstrapHowSubsWorksModal(firstCall)}, 250);
        return;
    }
    containerParent.addEventListener('click', () => {
        injectModalCTA(containerParent);
    });
    if(firstCall) {
        injectModalCTA(containerParent);
    }
};

document.addEventListener('DOMContentLoaded', () => {
    bootstrapHowSubsWorksModal(true);
});